import React from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import { useTextResources } from '../../../language';
import { Guests } from '../../../api/services/next';
import moment from 'moment'
import { Form } from 'semantic-ui-react';
import TextInput from '../../shared/TextInput';
import { dateFormat } from '../../shared/constants';
import CheckboxWrapper from '../../shared/Checkbox';
import { endpoint } from '../../../api/http';
import { createExcelHeader } from '../../GridPanel/utility';

export const GuestReport = ()=>{
    const text = useTextResources()
    const dateFormatter = ({value})=>{
        return value&&moment(value).format(dateFormat) || null
    }

    const excelHeaderTitle = text("GuestReport");

    const guestFormatter = ({ value, row }) => {
        return row ? (
            <a
                target='_blank'
                rel='noopener noreferrer'
                href={`${endpoint}CRM/GuestProfile/index/#/profile/${row.Id}`}
            >
                {value}
            </a>
        ) : value || "";
    };

    const gridOptions = {
        search: {
            title: text("GuestReport"),
            fields: [
                <Form.Field
                key='FirstName'
                label={text('FirstName')}
                clearable
                control={TextInput}
                placeholder={text('FirstName')}
                />,
                <Form.Field
                key='LastName'
                label={text('LastName')}
                clearable
                control={TextInput}
                placeholder={text('LastName')}
                />,
                <Form.Field
                key='Phone'
                label={text('Phone')}
                clearable
                control={TextInput}
                placeholder={text('Phone')}
                />,
                <Form.Field
                key='Email'
                label={text('Email')}
                clearable
                control={TextInput}
                placeholder={text('Email')}
                />,
                <Form.Field
                    control={CheckboxWrapper}
                    label={text("FindSimilar")}
                    key='FindSimilar'
                />
            ],
            api: Guests.GetGuests,
            spec: {
                MaxResults: 3000
            }
        },
        grid: {
            columns: [
                { name: 'FirstName', title: text("FirstName") , formatter: guestFormatter},
                { name: 'LastName', title: text("LastName"), formatter: guestFormatter },
                { name: 'Email', title: text("Email") },
                { name: 'BirthDate', title: text("DateOfBirth"), formatter: dateFormatter },
                { name: 'Nationality', title: text("Nationality") },
                { name: 'Language', title: text("Language") },
                { name: 'Phone', title: text("Phone") },
                { name: 'LocationId', title: text("Location") },
                { name: 'VipId', title: text("VIP") },
            ],
            paging: true,
            excel: {
                customizeHeader: createExcelHeader(excelHeaderTitle),
            },
            export: true,
        }
    }
    return (<GridSearchTemplate options={gridOptions}/>)
}
